var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"am-text",class:[
		`am-text--${_vm.theme}`,
		`am-text--${_vm.type}`,
		{ 'is-dark': _vm.dark }
	]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }